"use strict";

var _regeneratorRuntime = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/builds/8base/client-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var R = __importStar(require("ramda"));

var FragmentsSchemaContainer =
/*#__PURE__*/
function (_react_1$default$Pure) {
  _inherits(FragmentsSchemaContainer, _react_1$default$Pure);

  function FragmentsSchemaContainer() {
    var _this;

    _classCallCheck(this, FragmentsSchemaContainer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FragmentsSchemaContainer).apply(this, arguments));
    _this.state = {
      introspectionQueryResultData: null,
      loading: true
    };
    return _this;
  }

  _createClass(FragmentsSchemaContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var uri, introspectionQueryResultData;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                uri = this.props.uri;
                this.setState({
                  loading: true
                });
                _context.next = 4;
                return fetchFragmentsSchema(uri);

              case 4:
                introspectionQueryResultData = _context.sent;
                this.setState({
                  loading: false,
                  introspectionQueryResultData: introspectionQueryResultData
                });

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          loading = _this$state.loading,
          introspectionQueryResultData = _this$state.introspectionQueryResultData;
      var children = this.props.children;
      return children({
        loading: loading,
        introspectionQueryResultData: introspectionQueryResultData
      });
    }
  }]);

  return FragmentsSchemaContainer;
}(react_1.default.PureComponent);

exports.FragmentsSchemaContainer = FragmentsSchemaContainer;

var fetchFragmentsSchema = function fetchFragmentsSchema(uri) {
  return __awaiter(void 0, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2() {
    var result, filteredData;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return fetch(uri, {
              body: JSON.stringify({
                operationName: 'FragmentsSchema',
                query: "\n        query FragmentsSchema {\n          __schema {\n            types {\n              kind\n              name\n              possibleTypes {\n                name\n              }\n            }\n          }\n        }\n      "
              }),
              headers: {
                'Content-Type': 'application/json'
              },
              method: 'POST'
            }).then(function (result) {
              return result.json();
            }).catch(function () {
              return {
                data: null
              };
            });

          case 2:
            result = _context2.sent;

            if (!R.isNil(result.data)) {
              _context2.next = 5;
              break;
            }

            return _context2.abrupt("return", null);

          case 5:
            filteredData = result.data.__schema.types.filter(function (type) {
              return type.possibleTypes !== null;
            });
            result.data.__schema.types = filteredData;
            return _context2.abrupt("return", result.data);

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
};